import { buttonsShowAll, navigations, hideThisWrappersOnLoggedIn } from './articleListedElements';

// skryje listovací buttony, tlačítko přihlásit a dividery
export const articleListedHideButtons = (): void => {
  buttonsShowAll.forEach((button) => {
    (button as HTMLElement).style.display = 'none';
  });
  navigations.forEach((navigation) => {
    navigation.style.display = 'none';
  });

  hideThisWrappersOnLoggedIn.forEach((wrapper) => {
    (wrapper as HTMLElement).style.display = 'none';
  });
};
